import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormInput, ProjectListHeader, ActionWithPlus } from '../../../components'
import { back, push } from '../../../actions/nav-actions'
import { putRiskAndResilience, fetchRiskAndResilience } from '../../../api';
import { notify, getDictionary } from '../../../utils'

class EvaluateContext extends Component {
  state = {
    project: {},
    is_loading: false,
    error: undefined,
    data: {}
  }
  constructor(props) {
    super(props);
    this.request = this.request.bind(this);
    this.getParams = this.getParams.bind(this);
    this.client = getDictionary(props.dictionary);
    this.getText = this.getText.bind(this);
  }
  getText(tag, category = 'toc') {
    return this.client.get(category, tag);
  }
  getParams() {
    return this.props.match.params || {};
  }
  componentDidMount() {
    const params = this.getParams();
    this.setState({ is_loading: true, error: undefined }, () => {
      fetchRiskAndResilience(this.props.user.token,
        params.organization,
        params.code
      )
        .then((data) => this.setState({ is_loading: false, data }))
        .catch(err => this.setState({ is_loading: false, error: err }))
    });
  }
  request() {
    const params = this.getParams();
    putRiskAndResilience(
      this.props.user.token,
      params.organization,
      params.code,
      {
        ...this.state.data
      }
    )
      .then((data) => notify("Update informations", "Successfully updated!"))
      .catch((err) => notify('Error', err.message, 'error'))
  }
  render() {
    if (this.state.error) return <span>{this.state.error.message}</span>
    if (!this.state.data.risks || this.state.is_loading) return <span>Loading data...</span>
    let { questions, risks, factor } = this.state.data;
    return (
      <React.Fragment>
        <ProjectListHeader title="RISK AND RESILIENCE FACTORS" />
        <br />
        <div>
          {risks.map((risk, index) => {
            let style = "text-muted";
            if (factor.factors.indexOf(risk.id) !== -1) style = "text-info";
            return (
              <p>
                <a
                  href="#!"
                  key={index}
                  onClick={(event) => {
                    event.preventDefault();
                    let { factor } = this.state.data;
                    if (factor.factors.indexOf(risk.id) === -1)
                      factor.factors = factor.factors.concat([risk.id]);
                    else
                      factor.factors = factor.factors.filter(t => t !== risk.id);
                    this.setState({
                      data: { ...this.state.data, factor }
                    });
                  }}>
                  <span className={style}>{risk.name}</span>
                </a>
              </p>
            )
          })}
          {/**<ActionWithPlus
            onClick={() => {
              this.props.push(`/projects/${this.props.match.params.organization}/${this.props.match.params.code}/factors`)
            }}
            style={{ marginTop: 8 }}
          label="Add factor" />**/}
        </div>

        <br />
        <ProjectListHeader style={{ marginTop: 40 }} title="Guiding questions" />

        <p>{this.getText('risk_and_resilience_reducing_risk_question')}</p>
        <FormInput
          value={factor.questions.reducing_risk}
          onChange={(reducing_risk) => {
            let { factor } = this.state.data;
            factor.questions.reducing_risk = reducing_risk;
            this.setState({
              data: {
                ...this.state.data,
                factor
              }
            });
          }}

          placeholder="" />

        <p>{this.getText('risk_and_resilience_increasing_resilience_question')}</p>
        <FormInput
          value={factor.questions.increasing_resilience}
          onChange={(increasing_resilience) => {
            let { factor } = this.state.data;
            factor.questions.increasing_resilience = increasing_resilience;
            this.setState({
              data: {
                ...this.state.data,
                factor
              }
            });
          }}

          placeholder="" />

        {/** <div>
          {questions.map((question, index) => {
            return (
              <div key={index}>
                <p>Question:</p>
                <FormInput
                  value={question.description}
                  onChange={(value) => {
                    let { questions } = this.state.data;
                    questions[index].description = value;
                    this.setState({
                      data: {
                        ...this.state.data,
                        questions
                      }
                    });
                  }}
                  placeholder="" />
                <p>Answer:</p>
                <FormInput
                  value={question.value}
                  onChange={(value) => {
                    let { questions } = this.state.data;
                    questions[index].value = value;
                    this.setState({
                      data: {
                        ...this.state.data,
                        questions
                      }
                    });
                  }}
                  placeholder="" />
              </div>
            )
          })}
        </div>

        <ActionWithPlus
          onClick={() => {
            this.props.push(`/projects/${this.props.match.params.organization}/${this.props.match.params.code}/questions/risks`)
          }}
          style={{ marginTop: 8 }}
        label="Add question" /> **/}

        <div className="clearfix" />

        <button
          className="btn btn-info"
          onClick={this.request.bind(this)}
          style={{ marginTop: 24, marginBottom: 24 }}>
          SAVE
        </button>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({ ...state.localStorage, user: state.authReducer.user });

const mapDispatchToProps = dispatch => ({
  back() {
    dispatch(back())
  },
  push(routeName) {
    dispatch(push(routeName))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(EvaluateContext);


// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/ToCRiskAndResilienceFormularies.js